import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [invitationCode, setInvitationCode] = useState('');
  const [referralCode, setReferralCode] = useState('');
  const [referralInfo, setReferralInfo] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Check for referral code in URL
  useEffect(() => {
    const refCode = searchParams.get('ref');
    if (refCode) {
      setReferralCode(refCode.toUpperCase());
      validateReferralCode(refCode);
    }
  }, [searchParams]);

  const validateReferralCode = async (code) => {
    try {
      const response = await axios.post(`${BACKEND_URL}/api/referrals/validate/${code}`);
      if (response.data.valid) {
        setReferralInfo(response.data);
      }
    } catch (error) {
      setReferralInfo(null);
    }
  };

  const handleReferralCodeChange = (e) => {
    const code = e.target.value.toUpperCase();
    setReferralCode(code);
    if (code.length >= 10) {
      validateReferralCode(code);
    } else {
      setReferralInfo(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    setLoading(true);
    const result = await register(name, email, password, invitationCode, referralCode);
    
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="flex items-center justify-center py-12 px-4">
          <div className="w-full max-w-md">
            <div className="bg-white dark:bg-[#1a2530] rounded-xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 text-center">
                Crear Cuenta
              </h2>
              
              {error && (
                <div className="mb-4 p-3 bg-red-100 dark:bg-red-900/30 border border-red-400 dark:border-red-700 text-red-700 dark:text-red-400 rounded">
                  {error}
                </div>
              )}
              
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Nombre Completo
                  </label>
                  <input
                    type="text"
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-[#283039] rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-[#283039] text-gray-900 dark:text-white"
                    placeholder="Juan Pérez"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-[#283039] rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-[#283039] text-gray-900 dark:text-white"
                    placeholder="tu@email.com"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Contraseña
                  </label>
                  <input
                    type="password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-[#283039] rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-[#283039] text-gray-900 dark:text-white"
                    placeholder="••••••••"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Confirmar Contraseña
                  </label>
                  <input
                    type="password"
                    required
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-[#283039] rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-[#283039] text-gray-900 dark:text-white"
                    placeholder="••••••••"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Código de Invitación <span className="text-xs text-gray-500">(Opcional)</span>
                  </label>
                  <input
                    type="text"
                    value={invitationCode}
                    onChange={(e) => setInvitationCode(e.target.value.toUpperCase())}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-[#283039] rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-[#283039] text-gray-900 dark:text-white"
                    placeholder="INF-XXXXXXXX o TRL-XXXXXXXX"
                  />
                  <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                    ¿Tienes un código promocional? Ingrésalo aquí para obtener beneficios especiales.
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Código de Referido <span className="text-xs text-gray-500">(Opcional)</span>
                  </label>
                  <input
                    type="text"
                    value={referralCode}
                    onChange={handleReferralCodeChange}
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-[#283039] text-gray-900 dark:text-white ${
                      referralInfo ? 'border-green-500' : 'border-gray-300 dark:border-[#283039]'
                    }`}
                    placeholder="GPTJDP-XXXXXXXX"
                  />
                  {referralInfo && (
                    <div className="mt-2 p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg">
                      <p className="text-sm text-green-700 dark:text-green-400">
                        ✓ Referido por: <strong>{referralInfo.referrer_name}</strong>
                      </p>
                      <p className="text-sm text-green-600 dark:text-green-500">
                        🎁 Recibirás <strong>{referralInfo.bonus_credits} créditos gratis</strong> al registrarte
                      </p>
                    </div>
                  )}
                  <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                    ¿Un amigo te invitó? Ingresa su código para recibir 500 créditos gratis.
                  </p>
                </div>
                
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 bg-primary text-white rounded-lg font-bold hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? 'Cargando...' : 'Registrarse'}
                </button>
              </form>
              
              <p className="mt-6 text-center text-sm text-gray-600 dark:text-gray-400">
                ¿Ya tienes cuenta?{' '}
                <Link to="/login" className="text-primary font-medium hover:underline">
                  Inicia sesión aquí
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;